import gql from "graphql-tag";
import PinnablePostFields from "../../fragments/engagement/PinnablePostFields";

export default gql`
  mutation PinPostReply($objectId: ID!) {
    pinPostReply(objectId: $objectId) {
      ...PinnablePostFields
    }
  }

  ${PinnablePostFields}
`;
